var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("h1", { staticClass: "title" }, [_vm._v(_vm._s(_vm.title))]),
      _c("p", { staticClass: "subtitle" }, [_vm._v(_vm._s(_vm.description))]),
      _c("hr"),
      _c("div", { staticClass: "level" }, [
        _c(
          "div",
          { staticClass: "level-left" },
          [
            _c("health-services-filter", { staticClass: "level-item" }),
            _c("hospitals-filter", { staticClass: "level-item" }),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "level-right" },
          [_c("date-filter", { staticClass: "level-item" })],
          1
        ),
      ]),
      _c("hr"),
      _vm._l(_vm.types, function (type, index) {
        return _c("chart-view", {
          key: index,
          attrs: { type: type, name: _vm.name },
        })
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }